<template>
    <transition name="crm-fade">
        <div class="crm-overlay" v-if="visible" @click.self="close" role="dialog" aria-modal="true">
            <div class="crm-modal">

                <!-- Close -->
                <button class="crm-close" @click="close" aria-label="Close">&times;</button>

                <!-- Body: left image sticky + right scrollable text -->
                <div class="crm-body">

                    <!-- Left: sticky image only -->
                    <div class="crm-left" v-if="image">
                        <div class="crm-img-wrap">
                            <img :src="image" :alt="title || 'story'" class="crm-img" />
                        </div>
                    </div>

                    <!-- Right: scrollable content -->
                    <div class="crm-right">
                        <h3 v-if="title" class="crm-title">{{ title }}</h3>
                        <p v-if="subtitle" class="crm-subtitle">{{ subtitle }}</p>
                        <div class="crm-description">{{ description }}</div>
                    </div>

                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "ContentReadMoreModal",
    props: {
        visible:  { type: Boolean, default: false },
        image:    { type: String,  default: "" },
        title:    { type: String,  default: "" },
        subtitle: { type: String,  default: "" },
        description: { type: String, default: "" }
    },
    watch: {
        visible(val) {
            document.body.style.overflow = val ? "hidden" : "";
        }
    },
    mounted() {
        window.addEventListener("keydown", this.onKey);
    },
    beforeDestroy() {
        window.removeEventListener("keydown", this.onKey);
        document.body.style.overflow = "";
    },
    methods: {
        close() {
            this.$emit("close");
        },
        onKey(e) {
            if (this.visible && e.key === "Escape") this.close();
        }
    }
};
</script>

<style scoped>
/* ── Overlay ───────────────────────────────── */
.crm-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 16px;
}

/* ── Modal ─────────────────────────────────── */
.crm-modal {
    position: relative;
    background: #fff;
    border-radius: 10px;
    width: 100%;
    max-width: 1100px;
    height: 84vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.22);
}

.crm-close {
    position: absolute;
    top: 14px;
    right: 18px;
    z-index: 10;
    background: rgba(0,0,0,0.45);
    border: none;
    font-size: 22px;
    line-height: 1;
    color: #fff;
    cursor: pointer;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.crm-close:hover { background: rgba(0,0,0,0.7); }

/* ── Body: two-column, fills modal height ─── */
.crm-body {
    display: flex;
    flex: 1;
    overflow: hidden;
    min-height: 0;
}

/* ── Left: image fills full height, no scroll ─ */
.crm-left {
    width: 42%;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
}

.crm-img-wrap {
    flex: 1;
    overflow: hidden;
    min-height: 0;
}

.crm-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
    display: block;
}

/* ── Right: only this scrolls ───────────────── */
.crm-right {
    flex: 1;
    overflow-y: auto;
    padding: 40px 36px 36px;
    min-height: 0;
}

.crm-title {
    font-size: 22px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0 0 8px;
    padding-right: 32px; /* space for close btn */
}

.crm-subtitle {
    font-size: 14px;
    font-weight: 700;
    font-style: italic;
    color: #f3922b;
    margin: 0 0 16px;
}

.crm-description {
    font-size: 15px;
    line-height: 1.8;
    color: #444;
    white-space: pre-line;
}

/* ── Responsive ─────────────────────────────── */
@media (max-width: 640px) {
    .crm-body { flex-direction: column; overflow-y: auto; }
    .crm-left { width: 100%; min-height: unset; border-right: none; border-bottom: 1px solid #ececec; padding: 20px; position: static; }
    .crm-img-wrap { max-height: 220px; }
    .crm-right { padding: 20px; }
}

/* ── Transition ─────────────────────────────── */
.crm-fade-enter-active, .crm-fade-leave-active { transition: opacity 0.2s; }
.crm-fade-enter, .crm-fade-leave-to { opacity: 0; }
</style>
